import lb from '@/lib/loopback';

export function countItems() {
  return lb
    .get('/Publicacoes/count')
    .then(res => res.count);
}

export function findItems(settings = {}) {
  return lb
    .find('/Publicacoes/filter', settings);
}

export function findItem(id, settings = {}) {
  return lb
    .find(`/Publicacoes/${id}`, settings);
}

export function updateItem(publicacao) {
  return lb.patch(`/Publicacoes/${publicacao.id}`, publicacao);
}

export function createItem(publicacao) {
  return lb.post('/Publicacoes/', publicacao);
}

export function removeItem(id) {
  return lb.delete(`/Publicacoes/${id}`);
}

export function removeItems(ids) {
  return lb.post('/Publicacoes/bulk-delete', { ids });
}

export function hideItems(ids) {
  return lb.post('/Publicacoes/bulk-hide', { ids });
}

export default {
  countItems,
  findItems,
  findItem,
  updateItem,
  createItem,
  removeItem,
};
